import React, { FC } from 'react'

import { IconShoppingBasketProps } from './IconShoppingBasket.types'
import * as Styled from './styles/IconShoppingBasket.style'

import { nonThemeableRules } from '../../ruleSet'

const IconShoppingBasket: FC<IconShoppingBasketProps> = ({
  size = nonThemeableRules.defaultSize as number as IconShoppingBasketProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconShoppingBasketProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M159.21 57.61A4 4 0 0 0 156 56h-49.29l-15-37.49a4 4 0 0 0-7.42 3L98.09 56H61.88l13.65-34.53a4 4 0 0 0-7.44-2.94L53.28 56H4a4 4 0 0 0-3.83 5.15l24 80A4 4 0 0 0 28 144h104a4 4 0 0 0 3.83-2.85l24-80a4 4 0 0 0-.62-3.54zM129 136H31L9.38 64h141.24z' />
        <path d='M80 72a4 4 0 0 0-4 4v48a4 4 0 0 0 8 0V76a4 4 0 0 0-4-4zm24 0a4 4 0 0 0-4 4v48a4 4 0 0 0 8 0V76a4 4 0 0 0-4-4zm-48 0a4 4 0 0 0-4 4v48a4 4 0 0 0 8 0V76a4 4 0 0 0-4-4zm-24 0a4 4 0 0 0-4 4v16a4 4 0 0 0 8 0V76a4 4 0 0 0-4-4zm96 24a4 4 0 0 0 4-4V76a4 4 0 0 0-8 0v16a4 4 0 0 0 4 4z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconShoppingBasket
